import { render, staticRenderFns } from "./binsReclassification.vue?vue&type=template&id=6f764485&"
import script from "./binsReclassification.vue?vue&type=script&lang=js&"
export * from "./binsReclassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports